import { NgModule } from '@angular/core';

import { PageComponent } from './page.component';
import { SharedModule } from '@app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { BlockListComponent } from './block-list/block-list.component';
import { BannerBlockComponent } from './blocks/banner-block/banner-block.component';
import { CarouselBlockComponent } from './blocks/carousel-block/carousel-block.component';
import { ChallengeBlockComponent } from './blocks/challenge-block/challenge-block.component';
import { DiscoverContentBlockComponent } from './blocks/discover-content-block/discover-content-block.component';
import { FeatureHighlightComponent } from './blocks/feature-highlight/feature-highlight.component';
import { LearningPathBlockComponent } from './blocks/learning-path-block/learning-path-block.component';
import { LoginPromoComponent } from './blocks/login-promo/login-promo.component';
import { TestimonialsComponent } from './blocks/testimonials/testimonials.component';
import { TextImageComponent } from './blocks/text-image/text-image.component';
import { VideoBlockComponent } from './blocks/video-block/video-block.component';
import { WebinarsBlockComponent } from './blocks/webinars-block/webinars-block.component';
import { DashboardModule } from '@app/components/dashboard/dashboard.module';
import { ChaptersWidgetsModule, SharedLibraryModule } from 'library-explorer';
import { SlideBuilderModule } from '@app/components/slide-builder/slide-builder.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SharedLibraryModule,
    DashboardModule,
    SlideBuilderModule.forRoot({
      enableGlossaryTooltip: false
    }),
    ChaptersWidgetsModule
  ],
  exports: [PageComponent],
  declarations: [
    PageComponent,
    BlockListComponent,
    TextImageComponent,
    LoginPromoComponent,
    FeatureHighlightComponent,
    VideoBlockComponent,
    BannerBlockComponent,
    TestimonialsComponent,
    DiscoverContentBlockComponent,
    CarouselBlockComponent,
    WebinarsBlockComponent,
    LearningPathBlockComponent,
    ChallengeBlockComponent
  ]
})
export class PageModule { }
